import React, { useEffect, useState } from 'react';
import { CircularProgress, Stack, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { AccessLocationsAutosaver, AccessLocationsField } from './lib/accessLocationsAutosaver';

interface Props {
  autosaver: AccessLocationsAutosaver;
  userId: string;
  field: AccessLocationsField;
}

// Kept separate from the locations dropdown: re-rendering the dropdown resets its tree state
export const AccessLocationsSaveStatus = ({ autosaver, userId, field }: Props) => {
  const [status, setStatus] = useState(() => autosaver.getStatus(userId, field));

  useEffect(() => {
    setStatus(autosaver.getStatus(userId, field));
    return autosaver.subscribe(() => setStatus(autosaver.getStatus(userId, field)));
  }, [autosaver, userId, field]);

  if (status === 'pending' || status === 'saving') {
    return (
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <CircularProgress size={12} />
        <Typography variant="caption" color="text.secondary">
          Saving...
        </Typography>
      </Stack>
    );
  }

  if (status === 'saved') {
    return (
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <CheckIcon color="success" sx={{ fontSize: 14 }} />
        <Typography variant="caption" color="success.main">
          Saved
        </Typography>
      </Stack>
    );
  }

  if (status === 'error') {
    return (
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <ErrorOutlineIcon color="error" sx={{ fontSize: 14 }} />
        <Typography variant="caption" color="error">
          Not saved, please try again
        </Typography>
      </Stack>
    );
  }

  return null;
};
